"use client";

import Link from "next/link";
import Image from "next/image";

export function YiedlFooter() {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Quests", href: "/quests" },
    { name: "NFT Mint", href: "/nft-mint" },
    { name: "Referrals", href: "/referral" },
    { name: "Leaderboard", href: "/leaderboard" },
    // { name: "Profile", href: "/profile" },
  ];

  return (
    <footer className="w-full bg-yiedl-dark border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row items-center justify-between py-8 md:py-10 gap-6 md:gap-8">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link href="/">
              <Image
                src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/yield-logo.png"
                alt="Yiedl"
                width={120}
                height={40}
                className="h-8 w-auto"
              />
            </Link>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                href={link.href}
                className="text-sm md:text-base text-white hover:text-yiedl-primary transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Contact Us */}
          <div className="flex-shrink-0">
            <Link
              href="mailto:info@yiedl.ai"
              className="text-sm md:text-base text-white hover:text-yiedl-primary transition-colors duration-200"
            >
              Contact us
            </Link>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="border-t border-neutral-800 py-6">
          <div className="flex items-center justify-center text-sm text-neutral-400">
            <Link
              href="/terms"
              className="hover:text-white transition-colors duration-200"
            >
              Terms of Use & Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
